import { render, staticRenderFns } from "./ContactsTagGraph.vue?vue&type=template&id=b97955da&scoped=true&"
import script from "./ContactsTagGraph.vue?vue&type=script&lang=js&"
export * from "./ContactsTagGraph.vue?vue&type=script&lang=js&"
import style0 from "./ContactsTagGraph.vue?vue&type=style&index=0&id=b97955da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97955da",
  null
  
)

export default component.exports